import firebase from 'firebase';

let app = {};
let config = {};
let analytics = {
  logEvent: () => {},
};

function initializeFirebase(conf) {
  if (process.env.NODE_ENV !== 'test') {
    const appConfig = {
      apiKey: conf.REACT_APP_FIREBASE_API_KEY,
      appId: conf.REACT_APP_FIREBASE_APP_ID,
      authDomain: conf.REACT_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: conf.REACT_APP_FIREBASE_DATABASE_URL,
      measurementId: conf.REACT_APP_FIREBASE_MEASUREMENT_ID,
      messageSenderId: conf.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
      projectId: conf.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: conf.REACT_APP_FIREBASE_STORAGE_BUCKET,
    };

    firebase.initializeApp(appConfig);
    const remoteConf = firebase.remoteConfig();
    remoteConf.settings = {
      minimumFetchIntervalMillis:
        process.env.NODE_ENV == 'development' ? 100 : 300000,
      fetchTimeoutMillis: 10000,
    };

    remoteConf.defaultConfig = {
      api_gateway: 'UNKNOWN_API_GATEWAY',
    };

    remoteConf.fetchAndActivate();

    app = firebase;
    config = remoteConf;
    analytics = firebase.analytics();

    /*
    #TODO: Add logic here to pull from local dev if needed.
    Maybe a map?
    -- TJC - August 19, 2020
  */
  }
}

const setUserId = (userId) => {
  analytics.setUserId(userId);
};

const getConfig = (key = null) => {
  let configStr = config.getValue('config').asString();
  let configObj = JSON.parse(configStr);

  if (key != null) {
    return configObj[key];
  } else {
    return configObj;
  }
};

export { analytics, app, config, getConfig, initializeFirebase, setUserId };
